/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li2_LabelInputs */

const tr_mesafeli_s20_li2_label = /** @type {(inputs: Mesafeli_S20_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tacir sıfatını haiz Müşteriler için:`)
};

const en_mesafeli_s20_li2_label = /** @type {(inputs: Mesafeli_S20_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Customers with merchant status:`)
};

const de_mesafeli_s20_li2_label = /** @type {(inputs: Mesafeli_S20_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Kunden mit Kaufmannseigenschaft:`)
};

const ru_mesafeli_s20_li2_label = /** @type {(inputs: Mesafeli_S20_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для Клиентов со статусом коммерсанта:`)
};

/**
* | output |
* | --- |
* | "For Customers with merchant status:" |
*
* @param {Mesafeli_S20_Li2_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li2_label = /** @type {((inputs?: Mesafeli_S20_Li2_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li2_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li2_label(inputs)
	if (locale === "de") return de_mesafeli_s20_li2_label(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li2_label(inputs)
	return tr_mesafeli_s20_li2_label(inputs)
});